import React from "react";
import { object, string, number, oneOfType } from "prop-types";
import { Row, Col, Badge } from "react-bootstrap";
import { getIllustraitTestTime } from "utils/helperFunctions";
import { getTestTypeBadgeClassName } from "containers/JobSetup/helpers";
import clockIcon from "resources/images/clock-2x.png";
import {
  EVALUATION_TOOLS_LIBRARY,
  clptSubTestIds,
} from "utils/helperConstants";
import { subTestIdToSubTestName } from "containers/TestBatteries/constants";

const AssessmentInfoBox = ({
  assessmentSettings,
  test,
  timeFactor,
  interviewType,
}) => {
  if (interviewType) {
    return (
      <Row className="videoInterviewInfoCard mx-0 mt-2">
        <Col>
          <Row className="mb-1">
            <Col lg={8} md={8} sm={8} className="my-auto">
              <Badge
                bsPrefix="badge-list-badge video-interview-tag"
                className="text-center test-type mb-0"
                style={{ letterSpacing: "0.5px" }}
              >
                STRUCTURED INTERVIEW
              </Badge>
            </Col>
          </Row>
          <Row>
            <Col>
              <h4 className="mb-0">
                {EVALUATION_TOOLS_LIBRARY[interviewType].label}
              </h4>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }

  if (test) {
    const testId = Number(test.get("testId"));
    const subTestId = test.get("subTestId");

    const timeMultiplier = timeFactor || 1;
    let timeAllowed;

    if (testId === 48 && assessmentSettings && assessmentSettings.get("48")) {
      const illustraitSettings = assessmentSettings.get("48");

      timeAllowed = `${
        getIllustraitTestTime(
          illustraitSettings.get("workStyles"),
          illustraitSettings.get("competencySet")
        ) * timeMultiplier
      }m`;
    } else if (
      testId === 57 &&
      clptSubTestIds.includes(String(subTestId)) &&
      assessmentSettings &&
      assessmentSettings.getIn(["57", "modules"])
    ) {
      timeAllowed = `${
        assessmentSettings.getIn(["57", "modules"]).size * 7 * timeMultiplier
      }m`;
    } else {
      let timeAllowedCalculation = 0;

      // CLIK v1, WAA
      if ([30, 50].includes(testId)) {
        // parseFloat is used to remove any trailing zeroes (15.0 -> 15)
        // Each test should be rounded to one decimal place for better test duration accuracy/transparency
        timeAllowedCalculation = parseFloat((10 * timeMultiplier).toFixed(1));
      } else {
        timeAllowedCalculation = parseFloat(
          ((test.get("timeAllowed") * timeMultiplier) / 60).toFixed(1)
        );
      }

      timeAllowed = `${timeAllowedCalculation}m`;
    }

    const badgeClassName = getTestTypeBadgeClassName(test.get("testType"));

    // If Test is RCAT(testId == 56) then display specific test title
    // If Test is Cognify(testId == 45) then display subTestAbbreviation
    let subTestName = "";
    if (Number(test.get("testId")) === 56) {
      subTestName = "Cognitive Aptitude Test - DFR Use Only";
    } else if (Number(test.get("testId")) === 45) {
      subTestName = test.get("subTestAbbreviation");
    } else if (Number(test.get("testId")) === 46) {
      subTestName = subTestIdToSubTestName[test.get("subTestId")];
    } else if (
      test.get("subTestId") === 137 &&
      test.get("subTestName").includes("v2")
    ) {
      subTestName = test.get("subTestName").replace(" v2", "");
    } else if (test.get("subTestName")) {
      subTestName = test.get("subTestName");
    } else if (test.get("testMakerTestName")) {
      subTestName = test.get("testMakerTestName");
    }

    return (
      <Row key={test.get("testId")} className="testBatteryInfoBox mx-0 mt-2">
        <Col>
          <Row className="mb-1">
            <Col lg={8} md={8} sm={8} className="my-auto">
              <Badge
                bsPrefix={`badge-list-badge ${badgeClassName}`}
                className="text-center test-type mb-0"
                style={{ letterSpacing: "0.5px" }}
              >
                {`${
                  test.get("testType")
                    ? test.get("testType").toUpperCase()
                    : "TESTMAKER"
                }${
                  test.get("testType") === "emotional" ? " intelligence" : ""
                } TEST`}
              </Badge>
            </Col>
            <Col lg={4} md={4} sm={4} className="my-auto">
              <div className="text-right">
                <span>
                  <img
                    src={clockIcon}
                    height="16"
                    width="16"
                    alt="clock"
                    className="mb-1"
                  />
                </span>
                <div
                  className="d-inline-block pl-1"
                  style={{ color: "#86888b" }}
                >
                  {timeAllowed}
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <h4 className="mb-0">{subTestName}</h4>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
  return "";
};
AssessmentInfoBox.propTypes = {
  assessmentSettings: object,
  test: object,
  timeFactor: oneOfType([number, string]),
  interviewType: string,
};

export default AssessmentInfoBox;
